export const supportsCardThumbnail = file =>
  ['image/jpeg', 'image/png', 'image/webp'].includes(file?.type);

export async function createCardThumbnail(file) {
  if (!supportsCardThumbnail(file)) return null;
  let image;
  let objectUrl;
  try {
    if (typeof createImageBitmap === 'function') {
      image = await createImageBitmap(file, { imageOrientation: 'from-image' });
    } else {
      objectUrl = URL.createObjectURL(file);
      image = await new Promise((resolve, reject) => {
        const element = new Image();
        element.onload = () => resolve(element);
        element.onerror = () => reject(new Error('Não foi possível ler a imagem.'));
        element.src = objectUrl;
      });
    }
    const width = image.width || image.naturalWidth;
    const height = image.height || image.naturalHeight;
    if (!width || !height || width * height > 60000000) throw new Error('Dimensões de imagem inválidas ou excessivas.');
    const scale = Math.min(1, 960 / Math.max(width, height));
    const canvas = document.createElement('canvas');
    canvas.width = Math.max(1, Math.round(width * scale));
    canvas.height = Math.max(1, Math.round(height * scale));
    const context = canvas.getContext('2d');
    if (!context) throw new Error('Não foi possível preparar a miniatura.');
    context.drawImage(image, 0, 0, canvas.width, canvas.height);
    const blob = await new Promise(resolve => canvas.toBlob(resolve, 'image/webp', 0.82));
    if (!blob || blob.type !== 'image/webp') throw new Error('Este navegador não conseguiu gerar a miniatura WebP.');
    return blob;
  } finally {
    if (image?.close) image.close();
    if (objectUrl) URL.revokeObjectURL(objectUrl);
  }
}
